
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitojyotilingadarshancab() {



    const cardData =
    {
        keyword: 'Mumbai to 5 Jyotirlinga Darshan Cab',
        heading: 'S9 Travels: Mumbai to 5 Jyotirlinga Darshan Cab',
        headingDescription: 'S9 Travels offers Mumbai to 5 Jyotirlinga Darshan Cab Service, ensuring a comfortable, safe, and spiritually enriching journey. Visit the revered Jyotirlingas – Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath – in a well-maintained cab, including spacious Innova and SUVs, for a smooth pilgrimage experience. Enjoy on-time pickups, professional drivers, affordable pricing, and 24/7 service for a hassle-free trip. Book your Mumbai to 5 Jyotirlinga Darshan Cab with S9 Travels and embark on a divine and peaceful journey!',


        top: 'Top Places to Visit in Jyotilinga with S9 Travels',

"topPlaces": [
    {
      "title": "Bhimashankar Jyotirlinga, Pune",
      "description": "Located in the Sahyadri hills, Bhimashankar is one of the 12 Jyotirlingas of Lord Shiva. It is believed to be the site where Lord Shiva defeated the demon Tripurasura. The temple is surrounded by lush greenery and is a popular destination for both devotees and trekkers. The Bhimashankar Wildlife Sanctuary nearby adds to the beauty of this spiritual place."
    },
    {
      "title": "Trimbakeshwar Jyotirlinga, Nashik",
      "description": "Situated near Nashik, Trimbakeshwar is one of the most revered Jyotirlingas in India. It is the origin of the sacred Godavari River, also called 'Ganga of the South.' The temple’s unique feature is the presence of three lingas representing Brahma, Vishnu, and Mahesh (Shiva). Devotees visit this temple for rituals like Narayan Nagbali Puja, which is performed to remove ancestral curses."
    },
    {
      "title": "Grishneshwar Jyotirlinga, Aurangabad",
      "description": "Located near the UNESCO-listed Ellora Caves, Grishneshwar Jyotirlinga is the smallest among the 12 Jyotirlingas but holds immense significance. The temple’s beautiful red stone architecture and intricate carvings make it a mesmerizing site. It is said that a devoted woman named Kusuma restored this Jyotirlinga with her unwavering faith. The temple is a must-visit for those exploring Ajanta and Ellora caves."
    },
    {
      "title": "Aundha Nagnath Jyotirlinga, Hingoli",
      "description": "Aundha Nagnath is believed to be the first Jyotirlinga, where Lord Shiva was worshipped by the Pandavas during their exile. The temple is around 1,000 years old and features stunning Hemadpanti-style architecture. Devotees believe that praying here grants protection from negative energies and brings divine blessings."
    },
    {
      "title": "Parli Vaijnath Jyotirlinga, Beed",
      "description": "Also known as Vaijnath Jyotirlinga, this temple is associated with the legend of Ravana, who tried to carry the Shiva Linga to Lanka. Due to divine intervention, he had to place it here. The temple is known for its medicinal properties and is believed to grant relief from ailments when visited with devotion. The serene atmosphere makes it a peaceful place for spiritual seekers."
    }
],

"services": [
  {
    "name": "Mumbai to 5 Jyotirlinga Darshan Cab Service",
    "description": "S9 Travels offers a reliable Mumbai to 5 Jyotirlinga Darshan cab service, ensuring a smooth and comfortable pilgrimage journey to the five revered Jyotirlingas. Our fleet of well-maintained cabs and professional chauffeurs provide a safe, convenient, and enriching spiritual experience."
  },
  {
    "name": "Book Mumbai to 5 Jyotirlinga Taxi",
    "description": "Booking a taxi for your 5 Jyotirlinga Darshan from Mumbai is easy with S9 Travels. Whether you need a one-way or round-trip service, we offer flexible booking options, ensuring you a comfortable and hassle-free journey to all five Jyotirlinga temples."
  },
  {
    "name": "Affordable Mumbai to 5 Jyotirlinga Pilgrimage Taxi",
    "description": "S9 Travels provides affordable Mumbai to 5 Jyotirlinga pilgrimage taxi services without compromising on comfort and safety. Our budget-friendly rates make it easy for you to visit all five Jyotirlingas while enjoying a comfortable and spiritual journey."
  },
  {
    "name": "Private Taxi for 5 Jyotirlinga Darshan from Mumbai",
    "description": "Experience a personalized pilgrimage with a private taxi for 5 Jyotirlinga Darshan from Mumbai. With S9 Travels, you can enjoy a private and dedicated ride, allowing you to travel at your own pace and explore the temples with ease, guided by experienced chauffeurs."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga One-Way or Round Trip",
    "description": "S9 Travels offers one-way and round-trip taxi services for your journey from Mumbai to the 5 Jyotirlingas. Whether you plan to visit all five temples in one go or prefer a round trip for more flexibility, our services are tailored to provide the best travel experience."
  },
  {
    "name": "5 Jyotirlinga Temple Tour by Taxi",
    "description": "Take a comprehensive 5 Jyotirlinga temple tour by taxi with S9 Travels. Our taxi service ensures a smooth and comfortable ride while visiting each of the sacred Jyotirlinga temples. Experience the spiritual essence of these divine locations in a well-organized and peaceful manner."
  },
  {
    "name": "Comfortable Travel from Mumbai to 5 Jyotirlinga",
    "description": "Travel comfortably from Mumbai to the 5 Jyotirlingas with S9 Travels. Our cabs are equipped with modern amenities to ensure you enjoy a stress-free and comfortable journey. Whether you are traveling solo or with a group, we provide a relaxed travel experience to make your pilgrimage peaceful."
  },
  {
    "name": "Luxury Taxi for 5 Jyotirlinga Darshan",
    "description": "For those seeking luxury and comfort during their pilgrimage, S9 Travels offers luxury taxis for the 5 Jyotirlinga Darshan. Travel in style with premium vehicles and enjoy high-end services during your spiritual journey, ensuring a luxurious and memorable experience."
  },
  {
    "name": "Group Travel to 5 Jyotirlinga from Mumbai",
    "description": "S9 Travels provides group travel services for the 5 Jyotirlinga pilgrimage from Mumbai. We offer spacious vehicles to accommodate your family, friends, or large groups, ensuring a coordinated and comfortable journey. With our professional drivers, your group can experience this spiritual journey together with ease."
  }
],

"tableData": [
  ["Mumbai to 5 Jyotirlinga Darshan Cab Service", "Book Mumbai to 5 Jyotirlinga Taxi"],
  ["Affordable Mumbai to 5 Jyotirlinga Pilgrimage Taxi", "Private Taxi for 5 Jyotirlinga Darshan from Mumbai"],
  ["Mumbai to 5 Jyotirlinga One-Way or Round Trip", "5 Jyotirlinga Temple Tour by Taxi"],
  ["Comfortable Travel from Mumbai to 5 Jyotirlinga", "Luxury Taxi for 5 Jyotirlinga Darshan"],
  ["Group Travel to 5 Jyotirlinga from Mumbai", ""],
  ["", ""]
],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Spiritual Journey",
    "WhyChoosedescription": "S9 Travels offers a comfortable Mumbai to 5 Jyotirlinga Darshan cab service, perfect for those seeking a spiritual experience. Our fleet of well-maintained vehicles, including the Toyota Innova, ensures a smooth and comfortable ride with ample space, air conditioning, and plush seating, making your journey to the Jyotirlingas peaceful and pleasant."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand the significance of timing for your spiritual journey. Our Mumbai to 5 Jyotirlinga Darshan cab service ensures punctual pick-ups and drop-offs, so you can visit all five temples at your own pace without delays, making your trip as convenient as possible."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced and professional drivers are familiar with the best routes to the five Jyotirlingas. They ensure a safe, smooth, and efficient ride, providing you with a stress-free experience as you travel to each sacred site on your journey."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for Mumbai to 5 Jyotirlinga Darshan cab services. We provide transparent pricing with no hidden charges. You will receive a clear breakdown of the cost during the booking process, allowing you to plan your budget with confidence."
  },
  {
    "WhyChooseheading": "Safety and Comfort on Your Darshan Journey",
    "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features like GPS tracking, airbags, and seat belts, ensuring that your journey to the 5 Jyotirlingas is both safe and comfortable, allowing you to focus on your spiritual experience."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your Jyotirlinga Darshan trip. Whether you need an early morning departure or a late-night return, we’re available to provide reliable service that fits your travel schedule."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Darshan Trip",
    "WhyChoosedescription": "We understand that every spiritual journey is unique. Whether you prefer to visit the temples in a specific order, need to make stops along the way, or require special arrangements, we offer customizable itineraries to suit your needs and ensure your 5 Jyotirlinga Darshan trip is as fulfilling as possible."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Mumbai to 5 Jyotirlinga Darshan cab with S9 Travels is easy and hassle-free. You can book your ride online through our website or mobile app, or reach out to our customer service team for personalized assistance, ensuring a smooth booking process for your spiritual journey."
  }
]












    }

    const faqData = [
        [
          {
            question: 'How can I book a 5 Jyotirlinga Darshan cab from Mumbai?',
            answer: 'Booking a 5 Jyotirlinga Darshan cab from Mumbai is simple! You can book your ride through our website, mobile app, or by contacting our customer service team for personalized assistance. We’ll ensure a smooth and comfortable journey to the sacred Jyotirlinga temples.',
          },
          {
            question: 'What types of vehicles are available for the 5 Jyotirlinga Darshan trip from Mumbai?',
            answer: 'We offer a variety of vehicles for your 5 Jyotirlinga Darshan trip from Mumbai, including sedans, SUVs, and luxury vehicles like the Toyota Innova. Choose the vehicle that suits your group size and comfort needs.',
          },
          {
            question: 'How long does the 5 Jyotirlinga Darshan trip from Mumbai take?',
            answer: 'The 5 Jyotirlinga Darshan trip from Mumbai typically takes 3-4 days as it involves visiting five important Jyotirlinga temples in different cities. We can customize the itinerary based on your time and preferences.',
          },
          {
            question: 'Can I complete the 5 Jyotirlinga Darshan trip in a day?',
            answer: 'Due to the distances between the Jyotirlinga temples, it is not possible to complete the 5 Jyotirlinga Darshan in a single day. We recommend booking a 3-4 day trip for a comfortable and relaxed experience.',
          },
          {
            question: 'Is there a fixed fare for the 5 Jyotirlinga Darshan cab service from Mumbai?',
            answer: 'The fare for the 5 Jyotirlinga Darshan trip from Mumbai depends on the vehicle type, trip duration, and additional services. Contact us for a customized quote, and we’ll provide you with transparent pricing based on your trip details.',
          },
          {
            question: 'Do you provide pick-up services from Mumbai for the 5 Jyotirlinga Darshan trip?',
            answer: 'Yes, we provide convenient pick-up services from anywhere in Mumbai, including hotels, homes, or other locations. Our drivers will ensure a smooth and timely start to your spiritual journey to the 5 Jyotirlinga temples.',
          },
          {
            question: 'Can I customize the itinerary for my 5 Jyotirlinga Darshan trip?',
            answer: 'Yes, we can customize your 5 Jyotirlinga Darshan itinerary based on your preferences. Whether you wish to visit specific temples first or explore nearby sights, we can tailor the trip to fit your schedule and needs.',
          },
          {
            question: 'Do you offer meals and accommodation during the 5 Jyotirlinga Darshan trip?',
            answer: 'Yes, we can assist you with meal and accommodation arrangements during your 5 Jyotirlinga Darshan trip. Let us know your preferences, and we will ensure your trip is as comfortable as possible.',
          },
          {
            question: 'Why should I choose S9 Travels for my 5 Jyotirlinga Darshan cab service from Mumbai?',
            answer: 'S9 Travels offers a reliable, safe, and comfortable journey for the 5 Jyotirlinga Darshan trip from Mumbai. Our professional drivers, well-maintained vehicles, and exceptional customer service ensure a smooth and spiritual experience during your pilgrimage.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Devotee',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked the 5 Jyotirlinga Darshan trip with S9 Travels from Mumbai, and it was an incredible spiritual journey. The vehicles were comfortable, and the driver was well-versed with the route. It was a smooth and peaceful trip, visiting all the sacred temples. I highly recommend S9 Travels for anyone planning a Jyotirlinga Darshan trip.”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Devotee',
          rating: [1, 1, 1, 1, 1],
          text: '“Our 5 Jyotirlinga Darshan trip from Mumbai with S9 Travels was truly a blessed experience. The trip was well-planned, and the driver was knowledgeable about the temples and routes. The vehicle was clean and comfortable, making our pilgrimage a relaxing and memorable one. I will definitely choose S9 Travels for any future spiritual trips.”',
        },
      ];
      
      
      
      
    
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
     
      
      
      


    return (
        <div>
        

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/80.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitojyotilingadarshancab;